// import $ from "jquery";
// window.jQuery = $;
// window.$ = $;

import { windowWatcher } from "./components/window-watcher";
import { dots } from "./components/dots";
// import { anchorLinks } from "./components/anchor-links";

window.main = window.main || {};

let isHomepage = false;
let isTouchDevice = false;

main.init = () => {

  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains('page--is-homepage')) {
    isHomepage = true;
  }

  windowWatcher();
  dots(isHomepage, isTouchDevice);
  // anchorLinks();
};

document.addEventListener('DOMContentLoaded', main.init, false);